import React, {forwardRef, useImperativeHandle, useState, useRef, useEffect} from 'react'
import {Modal, DatePicker, Select, message, Input, Button} from 'antd'
import './index_iop.scss'
import moment from "moment";
import Tools from '../tools/Tools'
import InstructTypeSelect from './InstructTypeSelect'
import BatchDeviceSelect from './BatchDeviceSelect'
let formatTime = 'YYYY-MM-DD HH:mm:ss'
const Option = Select.Option;
let repeatObj = {
    1:365,
    2:52,
    3:12
}
let repeatDescObj = {
    1:Strings.rs14391,
    2:Strings.rs14392,
    3:Strings.rs14393
}
function AddBatchInstructModal(props, ref) {
    const [visible, setVisible] = useState(false)
    const [name, setName] = useState('')
    const [time, setTime] = useState('')
    const [rules, setRules] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)
    const [deviceCount, setDeviceCount] = useState(0)
    const [password, setPassword] = useState('')
    const [format, setFormat] = useState('')
    const [count, setCount] = useState('')
    const [routine, setRoutine] = useState(undefined)
    const [id, setId] = useState('')
    const [status, setStatus] = useState('')
    const [repeatCount, setRepeatCount] = useState(1)
    const [isAdd, setIsAdd] = useState(true)
    const deviceSelect = useRef(null)
    useImperativeHandle(ref, () => ({
        showModal: (id) => {
            setVisible(true)
            if(id) {
                setId(id)
                setIsAdd(false)
                getDetail(id)
            } else {
                setIsAdd(true)
            }
        }
    }))

    useEffect( ()=> {
        if(visible) {
            deviceSelect.current.reLoadSubTree(props.accountId)
        }
    },[visible])

    function getDetail(id) {
        let url = `${Tools.getApiUrl("taskDetail",this.props.platform)}${id}`
        Tools.fetch(url,'GET',function (data) {
            if (data.code === 0){
                let instructObj = data.data || {}
                setName(instructObj.name)
                setRoutine(instructObj.routine)
                setRules(instructObj.rules)
                setCount(instructObj.count)
                setFormat(instructObj.format)
                setStatus(instructObj.status)
                setTime(instructObj.time?moment(instructObj.time*1000):'')
                let imeis = []
                instructObj.deviceSimpleBean.map(function (item) {
                    imeis.push(item.imei)
                })
                deviceSelect.current.setSelectedDeviceList(imeis)
                deviceSelect.current.isDetail()
                getDeviceList(currentPage,isTakeSub,props.accountId)
            } else {
                message.error(data.message)
            }
        })
    }

    function hideModal() {
        setVisible(false)
        setName('')
        setRoutine('')
        setRules(0)
        setCount('')
        setFormat('')
        setTime('')
        setPassword('')
        deviceSelect.current.reset()
    }

    function handleOk() {
        let selectedDeviceList = deviceSelect.current.getSelectedDeviceList()
        let url = Tools.getApiUrl("addModifyTask",this.props.platform);
        if(!selectedDeviceList.length) {
            message.error(Strings.rs10424)
            return
        }
        if(Tools.isNull(routine)) {
            message.error(Strings.rs14358 || Strings.select5)
            return
        }
        if(Tools.isNull(password)) {
            message.error(Strings.rs10396 || Strings.inputPassword)
            return
        }
        if (repeatCount && rules && !count){
            message.error(Strings.rs14369)
            return
        }

        let model = {
            name,format,rules,password:hex_md5(password),time:moment(time).unix(),zoneId:Tools.getZoneName(),
            count,routine,
            devices: selectedDeviceList
        }
        if (!isAdd) {
            model.id = id
        }
        Tools.fetch(url,isAdd?'POST':'PUT',model,function (data) {
            if (data.code === 0) {
                hideModal()
                message.success(Strings.rs10411 || Strings.rs10360)
                props.refresh&&props.refresh()
            } else {
                message.error(data.message)
            }
        })
    }

    function getDeviceList(current,takeSub,id) {
        deviceSelect.current.getDeviceList(current,takeSub,id)
    }


    console.log(currentPage)
    return <Modal transitionName="" maskTransitionName=""
                  className="default_modal wid1000"
                  width=""
                  destroyOnClose={true}
                  visible={visible}
                  onCancel={hideModal}
                  maskClosable={false}
                  title={Strings.rs10093 || Strings.detail1}
                  footer={null}>
        <div className="maps-api-tip">
            <i className='icon-zhushi iconfont' style={{color: 'var(--BG-C)', fontSize: 16}}/>
            <div className="mar_left17">
                <div>{Strings.rs14359}</div>
                <div>{Strings.rs14360}</div>
            </div>
        </div>
        <div className="batch_instruct_content">
            <BatchDeviceSelect ref={deviceSelect} {...props}/>
            <div className="instruct_content">
                <div className={"modal_item"}>
                    <span className="form_span">{Strings.rs10836 || Strings.taskname}</span>
                    <div className={"form_value"}>
                        <Input value={name} placeholder={Strings.rs10846} maxLength={50}
                               onChange={(e) => setName(e.target.value.trim())}/>
                    </div>
                </div>
                <div className={"modal_item"}>
                    <span className="form_span">
                        <span style={{color: 'red'}}>*</span>{Strings.rs10155}
                    </span>
                    <div className={"form_value"}>
                        <InstructTypeSelect value={routine} platform={props.platform} onChange={setRoutine}/>
                    </div>
                </div>
                {routine === 0?<div  className={"modal_item mg_bottom10"}>
                    <span className="form_span"/>
                    <div className={"form_value"}>
                        <Input value={format}  type={'text'} autoComplete='new-password'
                               onChange={(e)=>setFormat(e.target.value.trim())}
                          placeholder={Strings.rs14362 || Strings.input6} maxLength={32}/>
                    </div>
                </div>:null}
                {routine === 0?<div  className={"modal_item"}>
                    <span className="form_span"/>
                    <div className={"form_value tip"}><span>{Strings.rs14363}</span></div>
                </div>:null}
                <div className={"modal_item mg_bottom10"}>
                    <span className="form_span">
                        <span style={{color: 'red'}}>*</span>{Strings.rs10037 || Strings.password}
                    </span>
                    <div className={"form_value"}>
                        <Input value={password} type={"password"} autoComplete='new-password'
                               onChange={(e)=>setPassword(e.target.value.trim())}
                               placeholder={Strings.rs10396 || Strings.inputPassword} maxLength={32}/>
                    </div>
                </div>
                <div  className={"modal_item"}>
                    <span className="form_span"/>
                    <div className={"form_value tip"}><span>{Strings.rs14364}</span></div>
                </div>
                <div className={"modal_item"}>
                    <span className="form_span">{Strings.lsTime}</span>
                    <div className={"form_value"}>
                        <DatePicker value={time ? moment(time, formatTime) : null}
                                    format={formatTime} allowClear={true}
                                    placeholder={Strings.rs14337}
                                    className="calendar"
                                    onChange={setTime}
                                    showToday={false}
                                    showTime={true}
                                    disabledDate={Tools.handleDisabledBeforeDate}/>
                    </div>
                </div>
                <div className={"modal_item mg_bottom0"}>
                    <span className="form_span">{Strings.rs14389}</span>
                    <div className={"form_value"}>
                        <Select value={rules} onChange={(value)=>{
                            setRules(value)
                            setCount(repeatObj[value])
                        }}>
                            <Option value={0}>{Strings.rs14365}</Option>
                            <Option value={1}>{Strings.rs14090}</Option>
                            <Option value={2}>{Strings.rs14091}</Option>
                            <Option value={3}>{Strings.rs14366}</Option>
                        </Select>
                    </div>
                </div>
                {rules? <div className={"modal_item mg_bottom0 mg_top15"}>
                    <span className="form_span">{Strings.rs14390}</span>
                    <div className={"form_value"}>
                        <Select value={repeatCount} onChange={setRepeatCount}>
                            <Option value={0}>{Strings.rs14367}</Option>
                            <Option value={1}>{Strings.rs14368}</Option>
                        </Select>
                    </div>
                </div>:null}
                {repeatCount && rules? <div className={"modal_item mg_bottom0 mg_top15"}>
                    <span className="form_span"/>
                    <div className={"form_value"}>
                      <Input value={count}
                                            onChange={(e)=>{
                                                let newCount = '';
                                                if(Tools.isNumber(e.target.value) && e.target.value <= repeatObj[rules] && e.target.value >= 1) {
                                                    newCount = Tools.getnum(e.target.value)
                                                    setCount(newCount)
                                                } else {
                                                    setCount('')
                                                }
                                            }}
                                            placeholder={repeatDescObj[rules]} maxLength={3}/>
                    </div>
                </div>:null}
                <div className="modal_item bottom_tip mg_top10">
                    {Strings.rs14370}
                </div>
            </div>
        </div>
        <div className="btn-row mg_top24">
            <Button className="mg_right10" onClick={hideModal}>{Strings.rs10054 || Strings.cancel}</Button>
            <Button type='primary' disabled={(!isAdd&&(status === 0 || status === 2))||Tools.isMonitor()} onClick={handleOk}>{Strings.rs10058 || Strings.sure}</Button>
        </div>
    </Modal>
}

export default forwardRef(AddBatchInstructModal)